export default {
	methods: {
		numberFormatter(value, format = ' ') {
			return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, `${format}`)
		}
	}
}